import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

export const LayoutHeader = () => {
  const dictionary = useUnitsPropertiesDictionary();

  return (
    <div className="flex gap-2.5 py-3 px-6">
      <BreadCrumbs
        crumbs={[
          {
            title: dictionary.Properties,
            href: "/properties"
          },
          {
            title: `Add ${dictionary.property}`,
            href: "/properties/add"
          }
        ]}
      />
    </div>
  );
};
